import { render, staticRenderFns } from "./CarrierForm.vue?vue&type=template&id=6c68c09a&"
import script from "./CarrierForm.vue?vue&type=script&lang=js&"
export * from "./CarrierForm.vue?vue&type=script&lang=js&"
import style0 from "./CarrierForm.vue?vue&type=style&index=0&id=6c68c09a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports